module.exports = __webpack_public_path__ + "static/media/attend_event_map_important.5322f466.svg";